// extracted by css-extract-rspack-plugin
export default {"container":"TrailingBadge-module__container__NQGPr","label":"TrailingBadge-module__label__LitTZ","title":"TrailingBadge-module__title__TIXQm"};